import { styled } from "@mui/material/styles";

import { getRelationKeyByValue } from "utils/relativeUtils";

export const PersonHead = styled("svg", {
  shouldForwardProp: (prop) => prop !== "relation",
})(({ theme, relation }) => {
  const relationKey = relation ? getRelationKeyByValue(relation) : null;

  const fillColor = relationKey
    ? theme.palette.relatives[relationKey]?.background
    : theme.palette.relatives.default.background;

  return {
    display: "block",
    marginBottom: 10,
    width: 56,
    [theme.breakpoints.up("mobile")]: {
      width: 86,
    },
    overflow: "hidden",
    cursor: "pointer",
    fill: fillColor,
  };
});

export const Peanut = styled("g", {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant }) => {
  const isWhiteVariant = variant === "white";

  return {
    opacity: isWhiteVariant ? 0.5 : 1,
  };
});

export const Plus = styled("svg")({
  stroke: "#FFF",
  zIndex: 1,
  width: "15%",
});
